<fdx-nav-main
  [nodes]="navMainNodes"
  [userProfile]="userProfile"
  class="d-block"
></fdx-nav-main>
<main role="main" class="container-fluid d-flex flex-column flex-grow-1">
  <router-outlet></router-outlet>
</main>
